import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

	private readonly SPINNER_TYPE: string = "spinner";
	private readonly ELLIPSIS_TYPE: string = "ellipsis";
	private readonly LOADING_TYPES: string[] = [ this.SPINNER_TYPE, this.ELLIPSIS_TYPE ];

	@Input()
	type: string = "spinner";

	constructor() {
	}

	ngOnInit() {
		this.type = this.LOADING_TYPES.indexOf( this.type ) == -1? this.SPINNER_TYPE: this.type;
	}

}
